export default __webpack_public_path__ + "static/link2-4cdb02c813967fdf848bacc8b6dee5ee.svg";